import CommonCheckbox from "@/components/Checkbox";
import CommonPopover from "@/components/Popover";
import { Resource } from "@/types/resource";
import { PopoverProps } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import React, { useEffect, useRef } from "react";

interface DownloadPopoverProps {
  // TODO: add props here
  list?: any[];
  children?: any;
  popoverConfig?: PopoverProps;
  type?: "select" | "download";
  onClickHandle?: (...item: any) => void;
}

interface ResourceSelectItemProps {
  item: Resource.skuListType;
  onClickCallBack?: (...item: any) => void;
  type: "select" | "download";
}

const ResourceSelectItem = (props: ResourceSelectItemProps) => {
  const { item, onClickCallBack, type } = props;
  const timerRef = useRef<any>(null);
  const onClickHandle = () => {
    if (timerRef.current != null) return;
    timerRef.current = setTimeout(() => {
      if (onClickCallBack && type === "download") {
        onClickCallBack("download", item);
      }
      timerRef.current = null;
    }, 300);
  };
  const onSelectHandle = (e: CheckboxChangeEvent) => {
    onClickCallBack && onClickCallBack("select", item.id);
  };
  useEffect(() => {
    return () => {
      timerRef.current && clearTimeout(timerRef.current);
    };
  },[])
  return (
    <div className={`download-popover-item ${type}`} onClick={onClickHandle}>
      {type === "select" && <CommonCheckbox checked={item?.isSelect} onChange={onSelectHandle} />}
      {item.name}
      {item.size && `(${item.size})`}
    </div>
  );
};
/**
 *  下载列表 气泡卡片
 * @param props
 * @returns
 */
const DownloadPopover = (props: DownloadPopoverProps) => {
  const {
    list = [],
    children,
    onClickHandle,
    type = "download",
    popoverConfig = {
      arrow: false,
    },
  } = props;
  if (list?.length > 0) {
    popoverConfig.content = list.map((item: any, index: number) => {
      return <ResourceSelectItem key={index} onClickCallBack={onClickHandle} item={item} type={type} />;
    });
  }

  return (
    <CommonPopover {...popoverConfig}>
      <>{children}</>
    </CommonPopover>
  );
};

export default React.memo(DownloadPopover);
